






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({ components: {} })
export default class onboarding_dialog extends Vue {
  @Prop({ type: Boolean, default: false }) public value!: boolean;
  @Prop({ type: Boolean, default: false }) public isEditingProfile!: boolean;
  @Prop({ type: String, default: "" }) public userName!: string;
  @Prop({ type: String, default: "Bajo" }) public experienceLevel!: string;
  @Prop({ type: Array, default: function(){ return ["Bajo","Medio","Alto"]; } }) public experienceOptions!: string[];

  public localName: string = "";
  public localLevel: string = "Bajo";

  mounted() { this.localName = this.userName || ""; this.localLevel = this.experienceLevel || "Bajo"; }

  @Watch("userName") onNameChanged(v: string) { this.localName = v || ""; }
  @Watch("experienceLevel") onLevelChanged(v: string) { this.localLevel = v || "Bajo"; }

  private onSave(): void {
    var name = this.localName && this.localName.trim().length > 0 ? this.localName : "Andrés";
    var level = this.experienceOptions.indexOf(this.localLevel) > -1 ? this.localLevel : "Bajo";
    this.$emit("save", { name: name, level: level });
  }
}
